import { apiClient } from "../../../lib";

export const stakeholderApi = {
    getStakeholders: async({
        page = 1,
        limit = 200,
        search = "",
        region = null
    }: {
        page?: number,
        limit?: number,
        search?: string,
        region?: string[] | null
    }) => {
        const params: Record<string, any> = {
            page,
            limit,
            ...(search && { search }),
            ...(region && region.length > 0 && { region_id: region})
        };

        const response = await apiClient.get('/stakeholders', { params });
        return response.data;
    }
};